import { createContext, useContext } from 'react';

/* Shared mutable proxy — read by useFrame in R3F, written by GSAP ScrollTrigger */
export const scrollProgress = { value: 0 };

const ScrollContext = createContext(scrollProgress);

export function useScrollProgress() {
  return useContext(ScrollContext);
}

export { ScrollContext };
export default ScrollContext;
